const ALERT_CLASS = "alert";
const ALERT_DANGER_CLASS = "alert-danger";
const ALERT_VALIDATION_CLASS = "alert-validation";
const MUI_ERROR_CLASS = "Mui-error";

export interface FormError {
    code: string;
    defaultMessage: string;
    field?: string;
    rejectedValue?: string;
    label?: string;
}

export function manageFieldError(error: FormError, formErrors: FormError[]): boolean {
    if (!error.field) {
        return false;
    }
    const input = document.getElementById(error.field);
    if (input) {
        appendErrorDivUnder(input, error);
    } else {
        // se busca el uso de FormError para pintar errores no asociados a inputs
        const formCustomErrors = document.getElementsByClassName("form_error_" + error.field);
        const formCustomError =
            formCustomErrors.length > 0 ? (formCustomErrors.item(0) as HTMLElement) : undefined;
        if (formCustomError) {
            appendErrorDivUnder(formCustomError, error);
        } else {
            console.error("No input/select/textarea/... found for id=" + error.field);
            formErrors.push(error);
        }
    }
    return true;
}

function appendErrorDivUnder(input: HTMLElement, error: FormError) {
    const parent = input.closest(".form-input");
    if (parent) {
        parent.classList.add(MUI_ERROR_CLASS);
        parent.querySelectorAll("*").forEach((elem) => elem.classList.add(MUI_ERROR_CLASS));
        error.label = parent.querySelector("label")?.textContent || error.field;
        const fieldMessage = document.createElement("div");
        fieldMessage.classList.add(ALERT_CLASS, ALERT_DANGER_CLASS, ALERT_VALIDATION_CLASS);
        fieldMessage.textContent = error.defaultMessage;
        parent.appendChild(fieldMessage);
    } else {
        console.error("No parent of type 'FormControl' found for input with id = " + error.field);
    }
}

export function manageFormErrors(formId: string, formErrors: FormError[]) {
    const form = document.getElementById(formId + "_errs");
    if (form) {
        formErrors.forEach((err) => {
            const alert = document.createElement("div");
            alert.classList.add(ALERT_CLASS, ALERT_DANGER_CLASS, ALERT_VALIDATION_CLASS);
            if (err.field) {
                const b = document.createElement("b");
                b.textContent = err.label || err.field;
                alert.appendChild(b);
                alert.appendChild(document.createTextNode(": " + err.defaultMessage));
            } else {
                alert.textContent = err.defaultMessage;
            }
            form.appendChild(alert);
        });
    } else {
        console.error("No form found for id=" + formId);
    }
}

export function manageErrors(errors: FormError[], formId: string) {
    const formErrors: FormError[] = [];
    errors.forEach((error) => {
        if (!manageFieldError(error, formErrors)) {
            formErrors.push(error);
        }
    });
    if (formErrors.length > 0) {
        manageFormErrors(formId, formErrors);
    }
}

export function removePreviousErrors() {
    let validations: HTMLCollectionOf<Element> =
        document.getElementsByClassName(ALERT_VALIDATION_CLASS);
    while (validations.length > 0) {
        validations[0].remove();
        validations = document.getElementsByClassName(ALERT_VALIDATION_CLASS);
    }
    const divs: HTMLCollectionOf<Element> = document.getElementsByClassName(MUI_ERROR_CLASS);
    for (let i = 0; i < divs.length; i++) {
        const val: Element = divs[i];
        val.classList.remove(MUI_ERROR_CLASS);
    }
}
